import confetti from 'canvas-confetti';

export function fireQuestConfetti(originElement?: HTMLElement | null) {
  let origin = { x: 0.5, y: 0.5 };
  if (originElement) {
    const rect = originElement.getBoundingClientRect();
    origin = {
      x: (rect.left + rect.width / 2) / window.innerWidth,
      y: (rect.top + rect.height / 2) / window.innerHeight,
    };
  }

  confetti({
    particleCount: 45,
    spread: 60,
    origin,
    colors: ['#a855f7', '#ec4899', '#f59e0b', '#10b981', '#3b82f6'],
    disableForReducedMotion: true,
  });
}

export function fireRewardConfetti() {
  const count = 200;
  const defaults = {
    origin: { y: 0.6 },
    colors: ['#fbbf24', '#f59e0b', '#ec4899', '#8b5cf6', '#10b981'],
    disableForReducedMotion: true,
  };

  function fire(particleRatio: number, opts: confetti.Options) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
    });
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });
  fire(0.2, {
    spread: 60,
  });
  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });
  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
}
